import PrimeVue from 'primevue/config'
import { FluencyTheme, FluencyPassThrough } from '../assets/js/primeVueTheme'
import Button from 'primevue/button'
import ButtonGroup from 'primevue/buttongroup'
import AutoComplete from 'primevue/autocomplete'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputMask from 'primevue/inputmask'
import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'
import Dialog from 'primevue/dialog'
import Popover from 'primevue/popover'
import Tooltip from 'primevue/tooltip'
import ProgressBar from 'primevue/progressbar'
import Paginator from 'primevue/paginator'
import Toast from 'primevue/toast'
import Password from 'primevue/password'
import Carousel from 'primevue/carousel'
import Message from 'primevue/message'
import DatePicker from 'primevue/datepicker'
import Panel from 'primevue/panel'
import Accordion from 'primevue/accordion'
import AccordionPanel from 'primevue/accordionpanel'
import AccordionHeader from 'primevue/accordionheader'
import AccordionContent from 'primevue/accordioncontent'
import Checkbox from 'primevue/checkbox'
import Menu from 'primevue/menu'
import Textarea from 'primevue/textarea'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import Select from 'primevue/select'
import Listbox from 'primevue/listbox'
import PanelMenu from 'primevue/panelmenu'
import Badge from 'primevue/badge'
import Chip from 'primevue/chip'
import SelectButton from 'primevue/selectbutton'
import ToggleSwitch from 'primevue/toggleswitch'
import RadioButton from 'primevue/radiobutton'
import RadioButtonGroup from 'primevue/radiobuttongroup'
import Skeleton from 'primevue/skeleton'
import InputOtp from 'primevue/inputotp'
import ColorPicker from 'primevue/colorpicker'
import MultiSelect from 'primevue/multiselect'
import Splitter from 'primevue/splitter'
import SplitterPanel from 'primevue/splitterpanel'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'
import Editor from 'primevue/editor'
import MenuBar from 'primevue/menubar'

export const primeVueInstall = (nuxtApp) => {
  const Vue = nuxtApp.vueApp

  Vue.use(PrimeVue, {
    zIndex: {
      overlay: 1986
    },
    theme: {
      preset: FluencyTheme,
      options: {
        darkModeSelector: 'none'
      }
    },
    pt: FluencyPassThrough
  })

  Textarea.extends.extends.props.fluid.default = true

  Select.extends.props.optionLabel = setOptionKey('text')
  Select.extends.props.optionValue = setOptionKey('value')
  MultiSelect.extends.props.optionLabel = setOptionKey('text')
  MultiSelect.extends.props.optionValue = setOptionKey('value')
  Vue.component('p-button', Button)
  Vue.component('p-button-group', ButtonGroup)
  Vue.component('p-input-text', InputText)
  Vue.component('t-input-text', InputText)
  Vue.component('p-input-number', InputNumber)
  Vue.component('p-input-group', InputGroup)
  Vue.component('p-input-group-addon', InputGroupAddon)
  Vue.component('p-input-icon', InputIcon)
  Vue.component('p-input-mask', InputMask)
  Vue.component('p-icon-field', IconField)
  Vue.component('p-tab', Tab)
  Vue.component('p-tabs', Tabs)
  Vue.component('p-tab-list', TabList)
  Vue.component('p-tab-panel', TabPanel)
  Vue.component('p-tab-panels', TabPanels)
  Vue.component('p-modal', Dialog)
  Vue.component('p-paginator', Paginator)
  Vue.component('p-password', Password)
  Vue.component('p-carousel', Carousel)
  Vue.component('p-message', Message)
  Vue.component('p-progress-bar', ProgressBar)
  Vue.component('p-toast', Toast)
  Vue.component('p-date-picker', DatePicker)
  Vue.component('p-popover', Popover)
  Vue.component('p-auto-complete', AutoComplete)
  Vue.component('p-panel', Panel)
  Vue.component('p-accordion', Accordion)
  Vue.component('p-accordion-panel', AccordionPanel)
  Vue.component('p-accordion-header', AccordionHeader)
  Vue.component('p-accordion-content', AccordionContent)
  Vue.component('p-menu', Menu)
  Vue.component('p-menu-item', Menu.components.PVMenuitem)
  Vue.component('p-textarea', Textarea)
  Vue.component('p-checkbox', Checkbox)
  Vue.directive('p-tooltip', Tooltip)
  Vue.component('p-card', Card)
  Vue.component('p-tag', Tag)
  Vue.component('p-select', Select)
  Vue.component('p-listbox', Listbox)
  Vue.component('p-panel-menu', PanelMenu)
  Vue.component('p-badge', Badge)
  Vue.component('p-chip', Chip)
  Vue.component('p-select-button', SelectButton)
  Vue.component('p-toggle-switch', ToggleSwitch)
  Vue.component('p-radio-button', RadioButton)
  Vue.component('p-radio-button-group', RadioButtonGroup)
  Vue.component('p-skeleton', Skeleton)
  Vue.component('p-input-otp', InputOtp)
  Vue.component('p-color-picker', ColorPicker)
  Vue.component('p-multi-select', MultiSelect)
  Vue.component('p-splitter', Splitter)
  Vue.component('p-splitter-panel', SplitterPanel)
  Vue.component('p-data-table', DataTable)
  Vue.component('p-column', Column)
  Vue.component('p-column-group', ColumnGroup)
  Vue.component('p-row', Row)
  Vue.component('p-editor', Editor)
  Vue.component('p-menu-bar', MenuBar)
}

const setOptionKey = (key) => ({
  type: [String, Function],
  default: () => (item) => (typeof item === 'object' && item.hasOwnProperty(key) ? item[key] : item)
})
